/**
 * AFS 1.1 — Annotation Format Schema
 *
 * Verbatim port of the hovercontext (was: agentation.com) /schema specification. Field names,
 * required/recommended/optional split, and value enums all match the
 * upstream doc. Downstream MCP tools speak this exact shape.
 */
export const AFS_VERSION = "1.1";
/* ------------------------------------------------------------------ */
/* Type guards                                                        */
/* ------------------------------------------------------------------ */
export const isPlacement = (a) => a.kind === "placement" && !!a.placement;
export const isRearrange = (a) => a.kind === "rearrange" && !!a.rearrange;
//# sourceMappingURL=afs.js.map